interface ILicense {
  license?: string;
  state?: string;
  type?: string;
  expiration?: string;
}

export const certificationOfComplianceWithDriverLicenseRequirements = ( license: ILicense, date: string ) => {
  return [
    { text: 'Certification Of Compliance With Driver License Requirements', style: 'h1' },

    { text: 'MOTOR CARRIER INSTRUCTION: The requirements in part 383 apply to every driver who operates in intrastate, interstate, or foreign commerce and operates a vehicle weighing 26,001 pounds or more, can transport more than 15 people, or transports hazardous materials that require placarding.', style: 'p', bold: true, },

    { text: 'The requirements in Part 391 apply to every driver who operates in interstate commerce and operates a vehicle weighing 10,001 pounds or more, can transport more than 15 people, or transports hazardous materials that require placarding.', style: 'p', bold: true },

    { text: 'DRIVER REQUIREMENTS: Parts 383 and 391 of the Federal Motor Carrier Safety Regulations contain requirements that you as a driver must comply with. They are as follows:', style: 'p', bold: true },

    {
      ol: [
        { text: "You, as a commercial vehicle driver, may not possess more than one license. The only exception is if a state requires you to have more than one license. If you currently have more than one license, you should keep the license from your state of residence, and return the additional licenses to the states that issued them. Destroying a license does not close the record in the state that issued it: you must notify the state. If a multiple license has been lost, stolen, or destroyed, you should close your record by notifying the state of issuance that you no longer want to be licensed by that state.", fontSize: 11, alignment: 'justify', margin: [0, 0, 0, 10]},
        { text: "Section 383.33 of the Federal Motor Carrier Safety Regulations requires that you notify your employer before the end of the NEXT BUSINESS DAY of any revocation or suspension of your driver’s license. §383.33 Notification of driver's license suspensions. Each employee who has a driver's license suspended, revoked, or canceled by a State or jurisdiction, who loses the right to operate a commercial motor vehicle in a State or jurisdiction for any period, or who is disqualified from operating a commercial motor vehicle for any period, shall notify his/her current employer of such suspension, revocation, cancellation, lost privilege, or disqualification. The notification must be made before the end of the business day following the day the employee received notice of the suspension, revocation, cancellation, lost privilege, or disqualification.", fontSize: 11, alignment: 'justify', margin: [0, 0, 0, 10]},
        { text: "In addition, Section 383.31 requires that any time you violate a state or local traffic law (other than parking), you must report it to your employing motor carrier and the state that issued your license within 30 days.", fontSize: 11, alignment: 'justify', margin: [0, 0, 0, 10]}
      ],
    },

    { text: '§383.31 Notification of convictions for driver violations:', style: 'p', margin: [10, 0, 0, 10] },

    {
      ol: [
        {
          text: "Except as provided in paragraph (d) of this section, each person who operates a commercial motor vehicle, who has a commercial learner's permit or commercial driver's license issued by a State or jurisdiction, and who is convicted of violating, in any type of motor vehicle, a State or local law relating to motor vehicle traffic control (other than a parking violation) in a State or jurisdiction other than the one which issued his/her permit or license, shall notify an official designated by the State or jurisdiction which issued such permit or license, of such conviction. The notification must be made within 30 days after the date that the person has been convicted.",
          fontSize: 11,
          alignment: 'justify',
          margin: [0, 0, 0, 10]
        },
        {
          text: "(b) Each person who operates a commercial motor vehicle, who has a commercial driver's license issued by a State or jurisdiction, and who is convicted of violating, in any type of motor vehicle, a State or local law relating to motor vehicle traffic control (other than a parking violation), shall notify his/her current employer of such conviction. The notification must be made within 30 days after the date that the person has been convicted. If the driver is not currently employed, he/she must notify the State or jurisdiction which issued the license according to §383.31(a).",
          fontSize: 11,
          alignment: 'justify',
          margin: [0, 0, 0, 10]
        },
        {
          stack: [
            {
              text: "(c) Notification. The notification to the State official and employer must be made in writing and contain the following information:",
              fontSize: 11,
              margin: [0, 0, 0, 10]
            },
            {
              ul: [
                { text: "Driver's full name;", fontSize: 11 },
                { text: "Driver's license number;", fontSize: 11 },
                { text: "Date of conviction;", fontSize: 11 },
                {
                  text: "The specific criminal or other offense(s), serious traffic violation(s), and other violation(s) of State or local law relating to motor vehicle traffic control, for which the person was convicted and any suspension, revocation, or cancellation of certain driving privileges which resulted from such conviction(s);",
                  alignment: 'justify',
                  fontSize: 11,
                },
                { text: "Indication whether the violation was in a commercial motor vehicle;", fontSize: 11 },
                { text: "Location of offense; and", fontSize: 11 },
                { text: "Driver's signature.", fontSize: 11 }
              ],
            }
          ],
          margin: [0, 0, 0, 10]
        },
        {
          text: "(d) A person is considered to be in compliance with the requirements of paragraph (a) of this section if the conviction occurs in a State or jurisdiction that is in substantial compliance with 49 CFR 384.209 and has not been de-certified in accordance with 49 CFR 384.405.",
          fontSize: 11,
          alignment: 'justify',
          margin: [0, 0, 0, 10]
        },
        {
          text: "You are responsible for ensuring your driver's license is current. You may not be dispatched by Sierra if your driver's license expiration date is within 10 days. Note that the Medical Examiner's Certificate is also included in this requirement.",
          fontSize: 11,
          alignment: 'justify',
          margin: [0, 0, 0, 10]
        },
        {
          text: "Sierra Expediting reserves the right to invoke financial penalties, refusal to dispatch, or permanent dismissal of a driver for the driver's failure to report suspensions/revocations per item 2 and citations per item 3 to Sierra Expediting Inc.",
          fontSize: 11,
          alignment: 'justify',
          margin: [0, 0, 0, 10]
        }
      ]
    },

    { text: 'DRIVER CERTIFICATION: I certify that I have read and understand the above requirements.', style: 'p', bold: true, },

    { text: 'The following license is the only one I will possess. I agree to report to Sierra Expediting Inc. any suspension/revocation of my CDL by the next business day and all traffic violations within 30 days of conviction.', style: 'p', bold: true, alignment: 'justify' },

    { canvas: [
        // License
        {
          type: 'line',
          x1: 0,
          y1: 0,
          x2: 150,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
        // State
        {
          type: 'line',
          x1: 170,
          y1: 0,
          x2: 320,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
        // Exp. date
        {
          type: 'line',
          x1: 340,
          y1: 0,
          x2: 490,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
      ],
      style: 'input',
      margin: [0, 20, 0, 0],
    },

    { text: `${license.license}`, margin: [0,-16, 0, 0]},
    { text: "Driver's License #", style: 'label', margin: [0,4,0,0]},
    { text: `${license.state}`, margin: [170,-30, 0, 0]},
    { text: "State", style: 'label', margin: [170,4,0,0]},
    { text: `${license.expiration}`, margin: [340,-30, 0, 0]},
    { text: "Exp. Date", style: 'label', margin: [340,4,0,0] },

    {
      canvas: [
        // Signature line
        {
          type: 'line',
          x1: 0,
          y1: 0,
          x2: 150,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
        // Date line
        {
          type: 'line',
          x1: 500,
          y1: 0,
          x2: 340,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
      ],
      style: 'input',
      margin: [0, 40, 0, 0]
    },

    { text: "Driver's Signature", style: 'label', margin: [0, 2, 0, 0] },
    { text: `${date}`, margin: [340, -32, 0, 0] },
    { text: "Date", style: 'label', margin: [340, 5, 0, 0] },

    { text: '', pageBreak: 'before' },
  ];
};